module.exports = __webpack_public_path__ + "static/media/productBoxes.4b95cbc8.svg";